import { render, staticRenderFns } from "./RecoverySent.vue?vue&type=template&id=7af035da&scoped=true&"
import script from "./RecoverySent.vue?vue&type=script&lang=js&"
export * from "./RecoverySent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af035da",
  null
  
)

export default component.exports